export const FIELDS = {
  ID: 'id',
  NAME: 'name',
};

export const ALERT_TYPE_ID = {
  INFO: 1,
  COUNTERFEIT: 2,
  LOOKING_FOR: 3,
  RESTOCK: 4,
  WARNING: 5,
  HOT: 6,
};

export const ALERT_ICON = {
  [ALERT_TYPE_ID.INFO]: 'info-circle',
  [ALERT_TYPE_ID.COUNTERFEIT]: 'times-circle',
  [ALERT_TYPE_ID.LOOKING_FOR]: 'search',
  [ALERT_TYPE_ID.RESTOCK]: 'refresh',
  [ALERT_TYPE_ID.WARNING]: 'exclamation-circle',
  [ALERT_TYPE_ID.HOT]: 'fire',
};

export const ALERT_COLOR = {
  [ALERT_TYPE_ID.INFO]: 'primary',
  [ALERT_TYPE_ID.COUNTERFEIT]: 'dark',
  [ALERT_TYPE_ID.LOOKING_FOR]: 'secondary',
  [ALERT_TYPE_ID.RESTOCK]: 'success',
  [ALERT_TYPE_ID.WARNING]: 'warning',
  [ALERT_TYPE_ID.HOT]: 'danger',
};

export const ALERT_NAME = {
  [ALERT_TYPE_ID.INFO]: 'Info',
  [ALERT_TYPE_ID.COUNTERFEIT]: 'Counterfeit',
  [ALERT_TYPE_ID.LOOKING_FOR]: 'Looking for',
  [ALERT_TYPE_ID.RESTOCK]: 'Restock',
  [ALERT_TYPE_ID.WARNING]: 'Warning',
  [ALERT_TYPE_ID.HOT]: 'Hot',
};

